export const SWIMLANE_TYPE_LABELS: Record<number, string> = {
  0: 'None',
  1: 'Assignee',
  2: 'Epic',
  3: 'Priority'
};

export const ISSUE_STATUS_OPTIONS = [
  { value: 0, label: 'Open' },
  { value: 1, label: 'In Progress' },
  { value: 3, label: 'Done' },
  { value: 4, label: 'Closed' },
  { value: 5, label: 'Reopened' },
  { value: 6, label: 'Blocked' },
  { value: 11, label: 'To Do' },
  { value: 12, label: 'QA' },
  { value: 8, label: 'Draft' },
  { value: 9, label: 'On Hold' }
];

export interface KanbanFilterOptionDto {
  value: string;
  label: string;
}

export interface KanbanIssueCardDto {
  id: string;
  key: string;
  summary: string;
  type: number;
  typeLabel: string;
  status: number;
  statusLabel: string;
  priority: number;
  priorityLabel: string;
  assigneeId?: string;
  assigneeName?: string;
  epicId?: string;
  epicKey?: string;
  storyPoints?: number;
  sortOrder: number;
  labels: string[];
  dueDate?: string;
  isOverdue?: boolean;
  delayInDays?: number;
  delayLabel?: string;
  remainingLabel?: string;
  deadlineBadge?: string;
}

export interface KanbanSwimlaneDto {
  key: string;
  label: string;
  issues: KanbanIssueCardDto[];
}

export interface KanbanColumnViewDto {
  id: string;
  name: string;
  mappedIssueStatus: number;
  mappedIssueStatusLabel: string;
  sortOrder: number;
  wipLimit?: number;
  issueCount: number;
  isWipExceeded: boolean;
  swimlanes: KanbanSwimlaneDto[];
}

export interface KanbanFilterOptionsDto {
  assignees: KanbanFilterOptionDto[];
  epics: KanbanFilterOptionDto[];
  labels: KanbanFilterOptionDto[];
  types: KanbanFilterOptionDto[];
  priorities: KanbanFilterOptionDto[];
}

export interface KanbanBoardDto {
  id: string;
  projectId: string;
  projectName: string;
  name: string;
  description?: string;
  isDefault: boolean;
  kind: number;
  swimlaneType: number;
  swimlaneTypeLabel: string;
  columnCount: number;
  createdAt: string;
  updatedAt?: string;
  defaultSavedFilterId?: string | null;
}

export interface KanbanBoardViewDto {
  id: string;
  projectId: string;
  projectName: string;
  name: string;
  description?: string;
  isDefault: boolean;
  swimlaneType: number;
  swimlaneTypeLabel: string;
  columns: KanbanColumnViewDto[];
  filterOptions: KanbanFilterOptionsDto;
  defaultSavedFilterId?: string | null;
}

export interface CreateKanbanBoardRequest {
  projectId: string;
  name: string;
  description?: string;
  isDefault?: boolean;
  swimlaneType?: number;
  createDefaultColumns?: boolean;
}

export interface KanbanBoardViewParams {
  search?: string;
  assigneeId?: string;
  epicId?: string;
  labelId?: string;
  type?: number;
  priority?: number;
  unassignedOnly?: boolean;
  savedFilterId?: string;
}
